import { IRetryPolicy, RetryContext } from '@microsoft/signalr';

//Reconnect immediately, then after 2 seconds, then after 10 seconds, then retry every 30 seconds forever
const DEFAULT_RETRY_DELAYS_IN_MILLISECONDS = [0, 2000, 10000, 30000];

export class SignalRReconnectPolicy implements IRetryPolicy {

	public nextRetryDelayInMilliseconds(retryContext: RetryContext): number | null {

		const index = Math.min(
			retryContext.previousRetryCount,
			DEFAULT_RETRY_DELAYS_IN_MILLISECONDS.length - 1);

		console.log('SignalR attempting to reconnect, attempt number: ', retryContext.previousRetryCount, 'sleep: ', DEFAULT_RETRY_DELAYS_IN_MILLISECONDS[index] + 'ms');
		return DEFAULT_RETRY_DELAYS_IN_MILLISECONDS[index];
	}
}
